import {Occupancy} from "@variocube/app-api";
import {
    Avatar,
    layout,
    PushButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    useOccupancies,
    useStorageItemValue
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useMemo} from "react";
import {CubeOrder, OrderStatus, OrderStorage, OrderType} from "../model";
import {CustomerCell, OrderCell, OrderStatusCell} from "./common";
import {useLocalization} from "../../i18n";

interface DeliveryTableProps {
    onStore: (order: CubeOrder) => void;
    onOpen: (boxNumber: string) => void;
}

export function DeliveryTable({onStore, onOpen}: DeliveryTableProps) {
    const {t} = useLocalization();
    const orders = useStorageItemValue<OrderStorage>("orders");
    const displayOrders = useMemo(() => {
        return Object.values(orders ?? {})
            .filter(order => order.orderType == OrderType.Cleaning)
            .filter(order => [OrderStatus.Cleaning, OrderStatus.WaitingReturn].indexOf(order.orderStatus) >= 0);
    }, [orders]);

    const occupancies = useOccupancies();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{t("Order")}</TableCell>
                    <TableCell>{t("Status")}</TableCell>
                    <TableCell>{t("Customer")}</TableCell>
                    <TableCell>{t("Box")}</TableCell>
                    <TableCell>{t("Action")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {displayOrders && displayOrders.map(order => {
                    const occupancy = occupancies.find(occupancy => occupancy.accessCode == order.accessCode);
                    return (
                        <DeliveryTableRow
                            order={order}
                            occupancy={occupancy}
                            key={order.orderId}
                            onStore={onStore}
                            onOpen={onOpen}
                        />
                    )
                })}
            </TableBody>
        </Table>
    );
}


interface DeliveryTableRowProps {
    order: CubeOrder;
    occupancy?: Occupancy;
    onStore: (order: CubeOrder) => void;
    onOpen: (boxNumber: string) => void;
}

function DeliveryTableRow({order, occupancy, onStore, onOpen}: DeliveryTableRowProps) {
    //const strings = useStrings(resources);
    const {t} = useLocalization();
    const handleOpenClick = useCallback(() => occupancy && onOpen(occupancy.boxNumber), [occupancy, onOpen]);
    const handleStoreClick = useCallback(() => onStore(order), [onStore, order]);

    return (
        <TableRow>
            <OrderCell order={order}/>
            <OrderStatusCell order={order}/>
            <CustomerCell order={order}/>
            <TableCell>
                {occupancy &&
                <Avatar size={1.5}>{occupancy.boxNumber}</Avatar>
                }
            </TableCell>
            <TableCell>
                <div className={layout.horizontal}>
                    {occupancy && (
                        <PushButton primary onClick={handleOpenClick}>
                            {t("Open")}
                        </PushButton>
                    )}
                    {!occupancy && (
                        <PushButton primary onClick={handleStoreClick}>
                            {t("Store")}
                        </PushButton>
                    )}
                </div>
            </TableCell>
        </TableRow>
    );
}
